import { IUpdateBooking } from "../../api/bookings/IUpdate";

function factoryUpdateBooking(): IUpdateBooking {
  return {
    status: "",
    customerCode: 0,
    tareWeight: 0,
    netWeight: 0,
    unitType: "",
    plateNumber: "",
    isCranable: false,
    iluCode: "",
    customsDocumentType: "",
    hazardousUpdateRequestDtos: [
      {
        id: 0,
        unNumber: "",
        adrClass: "",
        adrPackingGroup: "",
        adrNumberOfPackages: 0,
        adrNetWeight: 0,
        adrGrossWeight: 0,
      },
    ],
    cargoUpdateRequestDtos: [
      {
        id: 0,
        numberOfPackages: 0,
        goodsDescription: "",
        packageType: "",
        netWeight: 0,
        customsDocumentType: "",
        exportMRNNumber: "",
      },
    ],
  };
}

export const initialUpdateBooking = factoryUpdateBooking();
